import React, {Component} from 'react';
import { map } from "lodash";
import { message } from 'antd';
import moment from "moment-timezone";
import Loader from "../../../../../../Common/Component/Loader";
import Sidebar from '../../../../../../Common/Component/Sidebar';
import ServiceInfo from "./ServiceInfo";
import BillingInfo from "./BillingInfo";
import { errorHandle } from "../../../../../../Common/errorHandle";
import { TrophyOutlined } from '@ant-design/icons';

class ReviewService extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      loader: false,
      currentTab: 0,
      basicDetails:{},
      serviceInfo: {},
      billingInfo:{},
      customer: {},
      prepayInfo: {}
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  componentDidMount = () => {
    const { customerId } = this.props;
    this.props.resetCheckZipcode();
    this.props.resetPricingCalculator();
    this.onClearStorage();
    this.props.getServiceOrderEnquiry({user__uuid: customerId, limit: 1}); // get service order enquiry
    this?.props?.toggleSidebar && this.props.toggleSidebar(true);
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  UNSAFE_componentWillReceiveProps = (nextProps) => {

    if (Object.keys(nextProps?.serviceOrderEnquiry?.errors).length > 0 && 
      nextProps?.serviceOrderEnquiry?.errors !== this.props?.serviceOrderEnquiry?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.serviceOrderEnquiry?.errors);
    }

    if (Object.keys(nextProps?.serviceOrder?.errors).length > 0 &&
      nextProps?.serviceOrderEnquiry?.errors !== this.props?.serviceOrderEnquiry?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.serviceOrderEnquiry?.errors);
    }

    if (Object.keys(nextProps?.customerList?.errors).length > 0 && 
      nextProps?.customerList?.errors !== this.props?.customerList?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.customerList?.errors);
    }

    if (Object.keys(nextProps?.PricingCalc?.data).length > 0 && 
      nextProps?.PricingCalc?.data !== this.props?.PricingCalc.data) {
      this.setState({loader: false})
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  onClearStorage = () => {
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('basicDetail');
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  onTabChange = (value) => {
    this.setState({currentTab: value})
  };

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  setBasicData = (data) => {
    this.setState({ basicDetails: data }, () => {
      // console.warn('basicDetails', data);  
    });   
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  setServiceInfoData = (data) => {
    this.setState({ serviceInfo: data }, () => {
      // console.warn('serviceInfo', data);  
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  setBillingInfoData = (data) => {
    this.setState({ billingInfo: data }, () => {
      // console.warn('billingInfo', data);
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3495>Activate a Pending Residential Customer, Review and Update Service Details</DP-3495>
   */
  createServiceOrder = () => {
    const { basicDetails, serviceInfo, billingInfo} = this.state;
    const { customerId, PricingCalc } = this.props;
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    const { areaClean, otherCleaning } = serviceInfo;
    const idx = areaClean.indexOf("");
    if (idx > -1) {
      areaClean[idx] = otherCleaning;
    }
    if (customerId) {
      Promise.allSettled([
        this.props.updateServiceOrderEnquiry({
          uuid: serviceInfo?.service_uuid,
          field_office_uuid: serviceInfo?.field_office_uuid || '',
          service_type: 'residential',
          property_type: serviceInfo.propertyType || '',
          frequency: serviceInfo.frequency || '',
          service_add_ons: serviceInfo.add_ons || [],
          pet_count: serviceInfo?.is_extra_pet ? serviceInfo?.extra_pet : serviceInfo?.dogCount,
          pets: [],
          area_to_clean: areaClean || [],
          last_cleaned: serviceInfo.lastCleaned || '',
          service_address: {
            address: billingInfo?.service_address?.address,
            city: billingInfo?.service_address?.city,
            state: billingInfo?.service_address?.state,
            zip_code: billingInfo?.service_address?.zip_code
          },
          billing_address: {
            address: billingInfo?.billing_address?.address,
            city: billingInfo?.billing_address?.city,
            state: billingInfo?.billing_address?.state,
            zip_code: billingInfo?.billing_address?.zip_code
          },
          preferred_start_date: billingInfo?.preferred_start_date ? moment(billingInfo?.preferred_start_date).format("YYYY-MM-DD")  : null,
          is_billing_address_same: billingInfo?.isBillingAddress,
          first_name: basicDetails?.firstName,
          last_name: basicDetails?.lastName,
          email: basicDetails?.emails[0]?.email,
          phone_numbers: basicDetails?.phone_numbers,
          preferred_contact_methods: billingInfo?.contactMethods,
          cleaning_notes: serviceInfo.cleaningNotes || '',
          disposal_location: serviceInfo.disposalLocation || '',
          prepay_months: PricingCalc?.data?.prepay_months,
          is_prepaid: PricingCalc?.data?.is_prepaid,
          coupon_code: calcData?.coupon_code ? calcData?.coupon_code : '',
          is_authorize_charge_each_month: true,
          is_enquiry: true,
          user_uuid: `${customerId}`,
          is_print_and_mail_invoices:billingInfo.is_print_and_mail_invoices,
          is_email_invoice:billingInfo.is_email_invoice,
          payment_method_type:billingInfo?.payment_method
        })
      ]).then(result => {
        const isFulfilled = result.filter(x => x.status === "fulfilled");
        if (isFulfilled?.length > 0) {
          message.success("Service order enquiry created successfully.", 10);
          this.updateCustomer();
          !!this?.props?.setTable && this.props.setTab(0);
        } else {
          message.error("Error occur while call logged.", 10);
        }
      });
    } else {
      this.setState({ loader: false}, () => {
        message.error("Unable to find customer.", 10);
      });
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3040>Activate a Pending Residential Customer, Finalize</DP-3040>
   */
  updateCustomer = () => {
    const { customerId } = this.props;
    if (customerId) {
      Promise.allSettled([
        this.props.updateCustomer(customerId, { 
          "status": "active" 
        })
      ]).then(result => {
        const isFulfilled = result.filter(x => x.status === "fulfilled");
        if (isFulfilled?.length > 0) {
          message.success("Customer activated successfully.", 10);
          setTimeout(() => {
            this.props.cancelReviewService();
            this.onClearStorage();
            this.props.history.push('/residential')
          }, 1000);
        } else {
          message.error("Error occur while activate customer.", 10);
        }
      });
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  priceCalc = () => {
    const { serviceInfo } = this.state;
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    
    const {
      dogCount,
      frequency,
      areaClean,
      propertyType,
      lastCleaned,
      add_ons,
      extra_pet,
      is_extra_pet,
      field_office_uuid
    } = serviceInfo || {};
    const service_add_ons = []
    map(add_ons, obj => {
      if (obj?.add_on_uuid) service_add_ons.push({uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
    });
    const is_dog_count = is_extra_pet && parseInt(extra_pet) > 0 ? extra_pet : dogCount;

    if (field_office_uuid && frequency && is_dog_count && propertyType && lastCleaned) {
      this.setState({loader: true})
      const data = {
        'field_office_uuid': field_office_uuid,
        'frequency': frequency,
        'pet_count': is_dog_count,
        'last_cleaned': lastCleaned,
        'property_type': propertyType,
        'areas_to_clean': areaClean,
        'add_ons': service_add_ons,
        'is_prepaid': calcData && calcData.isPrePay ? calcData.isPrePay : false,
        'prepay_months': calcData && calcData.isPrePay && calcData.prepay_months && calcData.prepay_months !== 'null' ? calcData.prepay_months : null
      }
      
      if (calcData && calcData.coupon_code) Object.assign(data, {'coupon_code': calcData?.coupon_code});
      
      this.props.pricingCalculator(data);
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  renderTabs = () => {
    const { currentTab, basicDetails, serviceInfo, billingInfo } = this.state;
    switch (currentTab) {
    case 0:
      return(
        <ServiceInfo
          customerId={this.props.customerId}
          onTabChange={this.onTabChange}
          history={this.props.history}
          onChangeView={this.props.onChangeView} // for change parent view

          //reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          serviceOrderEnquiry={this.props.serviceOrderEnquiry}
          customerList={this.props.customerList}
          PricingCalc={this.props.PricingCalc}
          //GoogleApi={this.props.GoogleApi}
          Service={this.props.Service}

          //api
          getFieldOfficeById={this.props.getFieldOfficeById}
          getCustomerDetail={this.props.getCustomerDetail}
          priceCalc={this.priceCalc}
          checkZipCode={this.props.checkZipCode}
          resetCheckZipcode={this.props.resetCheckZipcode}

          pricingCalculator={this.props.pricingCalculator}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          
          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          serviceInfo={this.serviceInfo}
          deActivateCustomerConfirm={this.props.deActivateCustomerConfirm}
        />
      )
    case 1:
      return(
        <BillingInfo
          customerId={this.props.customerId}
          onTabChange={this.onTabChange}
          history={this.props.history}
          backToResidentialList = {this.backToResidentialList}

          //reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          serviceOrderEnquiry={this.props.serviceOrderEnquiry}
          customerList={this.props.customerList}
          PricingCalc={this.props.PricingCalc}

          GooleApi={this.props.GoogleApi}
          
          //api
          pricingCalculator={this.props.pricingCalculator}
          checkZipCode={this.props.checkZipCode}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetCheckZipcode={this.props.resetCheckZipcode}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          priceCalc={this.priceCalc}

          // addNewCard={this.props.addNewCard}
          
          getFieldOfficeById={this.props.getFieldOfficeById}
          // getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
          // FieldTechnicianFilter={this.props.FieldTechnicianFilter}

          basicDetails={basicDetails}
          serviceInfo={serviceInfo}
          billingInfo={billingInfo}

          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          setBillingInfoData={this.setBillingInfoData}
          createServiceOrder={this.createServiceOrder}
          ValidateCouponCode={this.props.ValidateCouponCode}
          validateCoupon={this.props.validateCoupon}
          deActivateCustomerConfirm={this.props.deActivateCustomerConfirm}
        />
      )
    default:
      return(
        <ServiceInfo
          customerId={this.props.customerId}
          onTabChange={this.onTabChange}
          history={this.props.history}
          onChangeView={this.props.onChangeView} // for change parent view

          //reducer
          zipcodeCheck={this.props.ZipcodeCheck}
          serviceOrderEnquiry={this.props.serviceOrderEnquiry}
          customerList={this.props.customerList}
          PricingCalc={this.props.PricingCalc}
          //GoogleApi={this.props.GoogleApi}
          Service={this.props.Service}

          //api
          getFieldOfficeById={this.props.getFieldOfficeById}
          getCustomerDetail={this.props.getCustomerDetail}
          priceCalc={this.priceCalc}
          checkZipCode={this.props.checkZipCode}
          resetCheckZipcode={this.props.resetCheckZipcode}

          pricingCalculator={this.props.pricingCalculator}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
        
          setServiceInfoData={this.setServiceInfoData}
          setBasicData={this.setBasicData}
          serviceInfo={this.serviceInfo}
        />
      )
    }
  }

  backToResidentialList = () =>{
    this.onClearStorage();
    this.props.history.push('/residential')
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  render() {
    const {loader} = this.state;
    return (
      <div id="wrapper">
        <div className="flex singleservice">
          {/* <div className="mt-10 mb-10 ml-30">
            <ul className="breadcrumb">
              <li  onClick={() => this.backToResidentialList()}  className="fs-14"><span className="pointer"><i className="las la-angle-left"></i> Back to All Residential Customers</span></li>
            </ul>
          </div> */}
          <Sidebar />
          <div className="fluid">
            {loader && <Loader />}
            {this.renderTabs()}
          </div>
        </div>
        
      </div>
    )
  }
}

export default ReviewService;